import {
    CHAGE_STUD_BIRTHDAY
} from '../constants/actionTypes'

export const addStudBirthday = (studentList) => {
    // console.log(studentList)
    studentList['stud_birthday'] = studentList['stud_birthday'] + 1
    return (dispatch) => {
        dispatch({type: CHAGE_STUD_BIRTHDAY, payload: {data: studentList}});
    }
}


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/addStudBirthday.jsx